// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EvRW","content":"styles_content__2kHz6"};